// extracted by mini-css-extract-plugin
export default {"Slogan":"styles_Slogan__erOUh","fade":"styles_fade__KG7Nb","scale":"styles_scale__aD62T"};